/**
 * Marks a portion of text intended to represent a letter
 */
export class Letter extends HTMLElement {
  _updateRendering() {
    // ...
  }
}
